import { PermissionOption } from '../sharedModules/permission/models/permissionOption.interface';
import { PermissionCommon } from '../sharedModules/permission/options/permissionCommon';
import { PermissionDelivery } from '../sharedModules/permission/options/permissionDelivery';
import { permissionExpressBasic } from '../sharedModules/permission/options/permissionExpressBasic';
import { permissionFavorites } from '../sharedModules/permission/options/permissionFavorites';
import { PermissionHistorical } from '../sharedModules/permission/options/permissionHistocal';
import { PermissionMassive } from '../sharedModules/permission/options/permissionMassive';
import { PermissionMessenger } from '../sharedModules/permission/options/permissionMessenger';
import { PermissionOperations } from '../sharedModules/permission/options/permissionOperations';
import { permissionPayments } from '../sharedModules/permission/options/permissionPayments';
import { permissionProfile } from '../sharedModules/permission/options/permissionProfile';
import { PermissionReceipts } from '../sharedModules/permission/options/permissionReceipts';
import { PermissionSameNextDay } from '../sharedModules/permission/options/permissionSameNextDay';
import { PermissionUser } from '../sharedModules/permission/options/permissionUser';

export const allPermissionOptionList: PermissionOption[] = [
  ...PermissionCommon,
  ...PermissionDelivery,
  ...PermissionOperations,
  ...PermissionHistorical,
  ...PermissionMessenger,
  ...PermissionMassive,
  ...PermissionUser,
  ...PermissionSameNextDay,
  ...permissionExpressBasic,
  ...permissionPayments,
  ...permissionFavorites,
  ...permissionProfile,
  ...PermissionReceipts,
];

export const dashboardMenu = {
  priority: 1,
  label: 'Operación',
  icon: 'mu-icon mu-icon-home',
  active: true,
  contextPath: 'operacion',
  baseRedirect: '/operacion/dashboard',
  routerLink: ['/operacion'],
  iconColor: '#0AAAC0',
  fontColor: '#0AAAC0',
};

export const deliveryMenu = {
  priority: 2,
  label: 'Domicilios',
  icon: 'mu-icon mu-icon-bike',
  active: true,
  contextPath: 'domicilios',
  baseRedirect: '/domicilios/pedidos-en-curso',
  iconColor: '#0AAAC0',
  fontColor: '#0AAAC0',
  items: [
    {
      label: 'Pedidos',
      icon: 'mu-icon mu-icon-pin',
      routerLink: ['/domicilios/pedidos-en-curso'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
    {
      label: 'Crear pedido',
      icon: 'mu-icon mu-icon-plus-circle',
      routerLink: ['/domicilios/crear'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
    {
      label: 'Puntos',
      icon: 'mu-icon mu-icon-store',
      routerLink: ['/puntos/lista'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
    {
      label: 'Crear punto',
      icon: 'mu-icon mu-icon-addstore',
      routerLink: ['/puntos/crear'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
  ],
};

export const expressBasicMenu = {
  priority: 3,
  label: 'Mensajeria',
  icon: 'mu-icon mu-icon-bolt',
  active: true,
  contextPath: 'express-basic',
  baseRedirect: '/express/solicitud-de-servicio',
  iconColor: '#E0CA22',
  fontColor: '#867914',
  items: [
    {
      label: 'Solicitar servicio',
      icon: 'mu-icon mu-icon-plus-circle',
      routerLink: ['/express/solicitud-de-servicio'],
      iconColor: '#E0CA22',
      fontColor: '#867914',
    },
    {
      label: 'Mis servicios',
      icon: 'mu-icon mu-icon-helmet',
      routerLink: ['/express/servicios'],
      iconColor: '#E0CA22',
      fontColor: '#867914',
    },
  ],
};
export const historicalMenu = {
  priority: 4,
  label: 'Historico',
  icon: 'mu-icon mu-icon-history ',
  active: true,
  contextPath: 'historico',
  baseRedirect: '/historico',
  routerLink: ['/historico'],
  iconColor: '#0AAAC0',
  fontColor: '#0AAAC0',
};
export const sameNextDayMenu = {
  priority: 5,
  label: 'Same | Next day',
  icon: 'mu-icon mu-icon-same-next-day',
  active: true,
  contextPath: 'same-next-day',
  baseRedirect: '/same-next-day/entregas',
  iconColor: '#44CB5B',
  fontColor: '#1B5124',
  items: [
    {
      label: 'Entregas',
      icon: 'mu-icon mu-icon-box-open',
      routerLink: ['/same-next-day/entregas'],
      iconColor: '#44CB5B',
      fontColor: '#1B5124',
    },
  ],
};

export const massiveMenu = {
  priority: 6,
  label: 'Distribución Masiva',
  icon: 'mu-icon mu-icon-building',
  active: true,
  contextPath: 'masivos',
  baseRedirect: '/masivos/create',
  iconColor: '#0AAAC0',
  fontColor: '#0AAAC0',
  items: [
    {
      label: 'Rutas',
      icon: 'mu-icon mu-icon-list',
      routerLink: ['/masivos/request'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
    {
      label: 'Cargar ruta',
      icon: 'mu-icon mu-icon-upload',
      routerLink: ['/masivos/create'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
    {
      label: 'Cedis',
      icon: 'mu-icon mu-icon-warehouse',
      routerLink: ['/cedi/list'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
    {
      label: 'Generar carta Porte',
      icon: 'mu-icon mu-icon-clipboard-list',
      routerLink: ['/masivos/cfdi'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
    {
      label: 'Nuevo ruteo masivos',
      icon: 'mu-icon-flag-checkered',
      routerLink: ['/masivos/new-routing'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
  ],
};

export const paymentsMenu = {
  priority: 7,
  label: 'Mi billetera',
  icon: 'mu-icon mu-icon-wallet',
  active: true,
  contextPath: 'metodos-de-pago',
  baseRedirect: '/metodos-de-pago/recargar-cuenta',
  iconColor: '#0AAAC0',
  fontColor: '#0AAAC0',
  items: [
    {
      label: 'Recargar cuenta',
      icon: 'mu-icon mu-icon-coins',
      routerLink: ['/metodos-de-pago/recargar-cuenta'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
    {
      label: 'Métodos de pago',
      icon: 'mu-icon mu-icon-credit-card',
      routerLink: ['/metodos-de-pago/metodo-pago'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
  ],
};

export const receiptsMenu = {
  priority: 8,
  label: 'MPay',
  icon: 'mu-icon mu-icon-dollar',
  active: true,
  contextPath: 'recaudos',
  baseRedirect: '/recaudos/historial',
  iconColor: '#0AAAC0',
  fontColor: '#0AAAC0',
  items: [
    {
      label: 'Datáfono MPay',
      icon: 'mu-icon mu-icon-credit-card',
      routerLink: ['/recaudos/historial'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
    {
      label: 'Movimientos',
      icon: 'mu-icon mu-icon-exchange',
      routerLink: ['/recaudos/dashboard'],
      iconColor: '#0AAAC0',
      fontColor: '#0AAAC0',
    },
  ],
};


export const favoriteAddressMenu = {
  priority: 9,
  label: 'Direcciones Favoritas',
  icon: 'mu-icon mu-icon-star',
  active: true,
  contextPath: 'direcciones-favoritas',
  baseRedirect: '/direcciones-favoritas/lista-de-direcciones',
  routerLink: ['/direcciones-favoritas/lista-de-direcciones'],
  iconColor: '#0AAAC0',
  fontColor: '#0AAAC0',
};
